/**
 * @generated SignedSource<<b89573cf866f521e733ec72c1235d700>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FormQuestionTarget = "GROUP" | "PLAYER";
export type FormQuestionType = "BOOLEAN" | "CHECKBOXES" | "EMAIL" | "GHIN_NUMBER" | "LONG_TEXT" | "MULTIPLE_CHOICE" | "NAME" | "PHONE_NUMBER" | "TEXT" | "TOGGLE" | "TRANSPORTATION";
export type QuestionVisibility = "NONE" | "OPTIONAL" | "REQUIRED";
import { FragmentRefs } from "relay-runtime";
export type useInitEventForm_formQuestionConfiguration$data = {
  readonly formConfiguration: {
    readonly formQuestionConfigurations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly enabled: boolean;
          readonly guestVisibility: QuestionVisibility;
          readonly id: string;
          readonly memberVisibility: QuestionVisibility;
          readonly prompt: string;
          readonly shortName: string | null | undefined;
          readonly target: FormQuestionTarget;
          readonly type: FormQuestionType;
          readonly values: ReadonlyArray<string | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "useInitEventForm_formQuestionConfiguration";
};
export type useInitEventForm_formQuestionConfiguration$key = {
  readonly " $data"?: useInitEventForm_formQuestionConfiguration$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitEventForm_formQuestionConfiguration">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitEventForm_formQuestionConfiguration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FormConfiguration",
      "kind": "LinkedField",
      "name": "formConfiguration",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormQuestionConfigurationConnection",
          "kind": "LinkedField",
          "name": "formQuestionConfigurations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FormQuestionConfigurationEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormQuestionConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "prompt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "guestVisibility",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "memberVisibility",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "values",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enabled",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "shortName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "target",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "0040d0a914ce08b09344aadee7037dff";

export default node;
